var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.can_check_prequalification)?_c('sButton',{on:{"click":_vm.openCheckPrequalification}},[_vm._v(" "+_vm._s(_vm.$t('Tenders.ConfirmSelection'))+" ")]):_c('CompleteRetraining',{attrs:{"tender":_vm.tender,"validate":_vm.validate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }